import React, { useEffect, useState, useContext } from "react";
import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { AuthContext } from "../../context/authContext/authContext";

import MUIDataTable from "mui-datatables";
import { IconButton, Popover, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import RemoveIcon from "@mui/icons-material/Remove";

import "moment/locale/es-mx";
import Filtros from "../../components/Filtros";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faMapLocation,
  faTableList,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { DetailUnidad, EditCreateUnidad } from "../../components/customComponents/Modals/ModalCreateEdit";
import { Spinner } from "../../components/Spinner";

const columns = [
  { name: "Unidad", label: "Unidad" },
  { name: "Número de Serie", label: "Número de Serie" },
  { name: "Marca/Modelo", label: "Marca/Modelo" },
  { name: "Placas", label: "Placas" },
  { name: "Cedis", label: "Cedis" },
  { name: "Disponibilidad", label: "Disponibilidad" },
  {
    name: "Acción",
    label: "Acción",
    options: {
      download: false, // 👈 visible pero no se exporta
      filter: false,
      sort: false,
    },
  },
];

// Toolbar con popup que recibe props
const ToolbarPopup = ({
  negocioId,
  tipoUnidadId,
  handleChange,
  handleOpenModalCrud,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) =>
    setAnchorEl(anchorEl ? null : event.currentTarget);

  const open = Boolean(anchorEl);
  const id = open ? "popup-empty" : undefined;
  const { user } = useContext(AuthContext);
  const viewFilter = [1, 2].includes(parseInt(user.negocio_id)) ? true : false;
  return (
    <>
      <IconButton
        onClick={handleClick}
        title={open ? "Cerrar Filtros Cliente" : "Abrir Filtros Cliente"}
      >
        {open ? <RemoveIcon /> : <TuneIcon />}
      </IconButton>
      <IconButton
        onClick={() => handleOpenModalCrud(null)}
        title="Crear Unidad"
      >
        <AddIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ bgcolor: "white" }} />
        <div style={{ padding: 16, maxWidth: 600 }}>
          <Filtros
            config={viewFilter ? ["negocio", "tipo_unidad"] : ["tipo_unidad"]}
            valores={{ negocioId, tipoUnidadId }}
            onChange={handleChange}
          />
        </div>
      </Popover>
    </>
  );
};

export const TableroUnidades = () => {
  useCeo({
    title: "Módulo de Administración de unidades",
    description: "Página de unidades",
  });
  const [data, setData] = useState([]);
  const { user } = useContext(AuthContext);
  const [negocioId, setNegocioId] = useState(user.negocio_id);
  const [cliente, setCliente] = useState("");
  const [tipoUnidadId, setTipoUnidadId] = useState(1);
  const [selectedUnidad, setSelectedUnidad] = useState(null);
  const [loading, setLoading] = useState(false);
  const [marcas, setMarcas] = useState([]);
  const [colores, setColores] = useState([]);

  const [showModalCrud, setShowModalCrud] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);

  const handleOpenModalCrud = (unidad_id) => {
    setSelectedUnidad(unidad_id);
    setShowModalCrud(true);
  };
  
  const handleCloseModalCrud = () => {
    setShowModalCrud(false);
    setSelectedUnidad(null);
  };

  const handleOpenModalDetail = (unidad_id) => {
    setSelectedUnidad(unidad_id);
    setShowModalDetail(true);
  };
  const handleCloseModalDetail = () => {
    setShowModalDetail(false);
    setSelectedUnidad(null);
  };
  
  const { getunidadesNegocio, deleteUnidad, getPosition, getCatalogos } =
    useUnidades();

  useEffect(() => {
    fetchUnidades();
  }, [negocioId, tipoUnidadId]);

  useEffect(() => {
    const fetchCatalogos = async () => {
      let resp = await getCatalogos(1);
      if (resp.ok) {
        setColores(resp.registros.camiones);
      } else {
        setColores([]);
      }

      resp = await getCatalogos(2);
      if (resp.ok) {
        setMarcas(resp.camiones.registros);
      } else {
        setMarcas([]);
      }
    };

    fetchCatalogos();
  }, []);
  const fetchUnidades = async () => {
    if (!negocioId) return;

    setData([]);
    try {
      setLoading(true);
      const resp = await getunidadesNegocio(negocioId, tipoUnidadId);
      setCliente(resp.cliente || "");
      if (resp.ok && Array.isArray(resp.unidades)) {
        const array = resp.unidades.map((unidad) => {
          const {
            unidad_id,
            unidad_numero,
            unidad_vin,
            unidad_marca,
            unidad_modelo,
            unidad_placas,
            cedi,
            baja,
            unidad_disponible,
            status,
          } = unidad;
          return [
            unidad_numero || "N/A",
            unidad_vin || "N/A",
            unidad_marca && unidad_modelo
              ? `${unidad_marca} - ${unidad_modelo}`
              : !unidad_marca && unidad_modelo
              ? unidad_modelo
              : unidad_marca && !unidad_modelo
              ? unidad_marca
              : "N/A",
            unidad_placas || "N/A",
            cedi ? cedi.nombre_cedis : "N/A",
            // baja ? "Deshabilitada" : !disponible ? "Ocupada" : "Disponible",
            baja
              ? "UNIDAD DESHABILITADA"
              : !baja && status
              ? status.nombre
              : "N/A",
            <>
              <FontAwesomeIcon
                onClick={() => {
                  if (!baja && unidad_disponible){
                    handleOpenModalCrud(unidad_id);
                  }else{
                    handleOpenModalDetail(unidad_id);
                  }
                   
                }}
                icon={!baja && unidad_disponible ? faEdit : faTableList}
                // style={{ cursor: "pointer", color: "blue" }}
                className={`col-3 fa-2x cursor ${
                  !baja && unidad_disponible ? "text-primary" : "text-success"
                }`}
                title={
                  !baja && unidad_disponible
                    ? "Editar unidad"
                    : "Ver detalle de asignación"
                }
              />

              <FontAwesomeIcon
                icon={baja ? faThumbsUp : faThumbsDown}
                className={`col-3 fa-2x text-${
                  baja ? "success" : "danger"
                } cursor`}
                title={
                  !unidad_disponible
                    ? "Acción no disponible"
                    : baja
                    ? "Dar de alta unidad"
                    : "Dar de baja unidad"
                }
                onClick={() => {
                  if (unidad_disponible) {
                    Swal.fire({
                      title: `¿Deseas ${
                        baja ? "habilitar" : "deshabilitar"
                      } la unidad ${unidad_numero}?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#3085d6",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "¡Sí!",
                      cancelButtonText: "No",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        return statusUnidad(unidad_id, baja);
                      }
                    });
                  }
                }}
              />
              <FontAwesomeIcon
                title="Obtener ubicación en BIT"
                onClick={() => {
                  if (!loading) {
                    obtenerUbicacion(unidad_id);
                  }
                }}
                className="col-3 fa-2x text-dark cursor"
                icon={faMapLocation}
              ></FontAwesomeIcon>
            </>,
          ];
        });
        setData(array);
      } else {
        setData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error al cargar tripulantes:", error);
    }
  };

  const options = {
    download: data.length > 0,
    selectableRows: "none",
    responsive: "standard", // mejor para tablas anchas
    fixedHeader: true, // mantiene header visible al hacer scroll
    downloadOptions: {
      filename: `${
        tipoUnidadId === 7 ? "Cajas" : "Unidades"
      } en Bitácora ${cliente}`,
      filterOptions: {
        useDisplayedColumnsOnly: false, // 👈 exporta también las ocultas
        useDisplayedRowsOnly: true,
      },
      charset: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) =>
      "\uFEFF" + buildHead(columns) + buildBody(data),
    customToolbar: () =>
      !loading ? ( // solo se muestra cuando ya cargó
        <ToolbarPopup
          negocioId={negocioId}
          tipoUnidadId={tipoUnidadId}
          handleChange={handleChange}
          handleOpenModalCrud={handleOpenModalCrud}
        />
      ) : null,
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  const handleChange = (campo, valor) => {
    if (campo === "tipo_unidad") setTipoUnidadId(valor); // 👉 solo guarda el id
    if (campo === "negocio") setNegocioId(valor); // 👉 solo guarda el id
    // if (campo === "tipo_unidad" && valor === "3") {
    //   setTipoUnidadId(valor);
    // } else {
    //   setTipoUnidadId(null);
    // }
  };

  const obtenerUbicacion = async (unidad_id) => {
    setLoading(true);
    const ubicacion = await getPosition(unidad_id);
    if (!ubicacion.ok) {
      Swal.fire({
        title: "Lo siento",
        text: ubicacion.msg,
        icon: "info",
      });
    } else {
      const url = `https://www.google.com/maps?q=${ubicacion.posicion_actual}`;
      window.open(url, "_blank"); // Abre en una nueva pestaña
    }
    setLoading(false);
  };

  const statusUnidad = async (unidad_id, activo) => {
    let resp = await deleteUnidad(unidad_id, {
      activo: activo,
    });

    if (resp.ok) {
      // await obtenerUsuarios();
      Swal.fire({
        title: "¡Completado!",
        text: resp.msg,
        icon: "success",
      });
    } else {
      Swal.fire({
        title: "No se pudo actualizar la unidad",
        text: resp.msg,
        icon: "error",
      });
    }
    fetchUnidades();
  };

  return (
    <>
      <div className="m-1">
        {loading && <Spinner />}
        <MUIDataTable
          title={
            loading
              ? "Cargando..."
              : `${
                  tipoUnidadId === 7 ? "Cajas" : "Unidades"
                } en Bitácora ${cliente}`
          }
          data={data}
          columns={columns}
          options={options}
        />
      </div>
      <EditCreateUnidad
        negocio_id={negocioId}
        unidad_id={selectedUnidad}
        marcas={marcas}
        colores={colores}
        show={showModalCrud}
        handleClose={handleCloseModalCrud}
        refreshUnidades={fetchUnidades} // <-- nuevo prop
      />
      <DetailUnidad
        unidad_id={selectedUnidad}
        show={showModalDetail}
        handleClose={handleCloseModalDetail}
      />
    </>
  );
};
